import { Box, CssBaseline, InputAdornment, Button, FormControl, InputLabel, OutlinedInput, Select, MenuItem, Container, Grid, SelectChangeEvent, TextField } from "@mui/material"
import NavAppBar from "../components/NavAppBar"
import { useAuth } from "../context/AuthProvider"
import { useState, useEffect } from "react"
import dataService from '../services/Data'
import CustomDialog from "../components/CustomDialog"
import CustomBasicTable from "../components/BasicTable"
import DownloadIcon from '@mui/icons-material/Download';
import { pdf } from '@react-pdf/renderer';
import { CotizadorPDF } from '../components/CotizadorPDF'
import { format } from "date-fns"

export const Cotizador = () => {
    const { user } = useAuth()
    const [datosVehiculos, setDatosVehiculos] = useState(null)
    const [vehiculo, setVehiculo] = useState(0)
    const [datosCreditos, setDatosCreditos] = useState(null)
    const [credito, setCredito] = useState(0)
    const [datosModelos, setDatosModelos] = useState(null)
    const [modelo, setModelo] = useState(0)
    const [capital, setCapital] = useState(null)
    const [cuotas, setCuotas] = useState(null)
    const [tasas, setTasas] = useState(null)
    const [vehiculoSelec, setVehiculoSelec] = useState(0)
    const [creditoSelec, setCreditoSelec] = useState(0)
    const [error, setError] = useState("")
    const [msjError, setMostrarMsjError] = useState(false)
    const [tiposCredID, setTiposCredID] = useState(null)

    dataService.setToken(user.data.token)
    useEffect(() => {
        dataService.listarVehiculosConTasas(setDatosVehiculos, false)
        dataService.listarCreditosConTasas(setDatosCreditos, false)
        dataService.listarVehiculosTiposCredModelosConTasas(setDatosModelos)
        //dataService.listarVehiculosTiposCredModelos(setDatosModelos)
    }, [])

    useEffect(() => {
        setCredito(null)
        { datosModelos && setTiposCredID(datosModelos.filter(item => item.vehiculoID == vehiculoSelec).map(row => row.tipoCreditoID)) }
        //do operation on state change
    }, [vehiculo])

    const handleCotizar = (credito, vehiculo, modelo, capital) => {
        if (vehiculo != 0 && datosVehiculos.find((item) => item.vehiculoID === vehiculo).adelantamientoCuota === true) {
            if (capital === 0 || capital === "" || capital === null || cuotas === 0 || cuotas === "" || cuotas === null) {
                setTimeout(() => {
                    setError("Complete todos los datos para simular la cotización.")
                    setMostrarMsjError(true)
                }, 30);
                console.log(msjError)
                return;
            }

            if (Number(capital) < 1000000) {
                setError("El capital debe ser mayor o igual a $1.000.000.")
                setMostrarMsjError(true)
                return;
            }

            if (Number(cuotas) < 3 || cuotas > 48) {
                setError("El plazo no puede ser menor a 3 meses ni mayor a 48 meses.")
                setMostrarMsjError(true)
                return;
            }
            setMostrarMsjError(false)
            dataService.listarDataCreditoPyme(vehiculo, getRawValue(capital), cuotas, user.data.usuarioID, setTasas)
        }
        else {
            if (vehiculoSelec === 0 || ((datosModelos.filter((veh) => veh.vehiculoID === vehiculo).length > 0) && ((credito === null || vehiculo === null || modelo === null)) || (capital === 0 || capital === "" || capital === null))) {
                setTimeout(() => {
                    setError("Complete todos los datos para simular la cotización.")
                    setMostrarMsjError(true)
                }, 30);
                console.log(msjError)
                return;
            }

            if (Number(capital) < 1000000) {
                setError("El capital debe ser mayor o igual a $1.000.000.")
                setMostrarMsjError(true)
                return;
            }
            console.log(getRawValue(capital));
            setMostrarMsjError(false)
            console.log(credito, vehiculo, modelo, getRawValue(capital));
            dataService.listarTasaByParam(credito, vehiculo, modelo, getRawValue(capital), user.data.usuarioID, setTasas)
        }
    }

    const handleCredito = (event) => {
        setCredito(event.target.value);
        setCreditoSelec(event.target.value);
    };

    const handleVehiculo = (event) => {
        setVehiculo(event.target.value);
        setVehiculoSelec(datosVehiculos.find((item) => item.vehiculoID === event.target.value).vehiculoID);
        setCredito(null)
        setCreditoSelec(null)
        setModelo(null)
        //setCapital(null)
        setTasas(null)
    };

    const handleModelo = (event) => {
        setModelo(event.target.value)
        setTasas(null)
    };

    const handleCapital = (event) => {
        const inputValue = event.target.value;
        const rawValue = parseInt(inputValue.replace(/[^\d]/g, '')) || 0;

        setCapital(formatNumber(inputValue))
        setTasas(null)
    };

    const handleCuotas = (event) => {
        const inputValue = event.target.value;
        const rawValue = parseInt(inputValue.replace(/[^\d]/g, '')) || 0;
        setCuotas(formatNumber(inputValue))
        setTasas(null)
    };

    const formatNumber = (value) => {
        if (!value) return value;
        const number = value.replace(/[^\d]/g, '');
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    const getRawValue = (value) => {
        return parseInt(value.replace(/[^\d]/g, '')) || 0;
    };

    const formatCurrency = (value) => {
        if (value === null || value === undefined || isNaN(value)) return '$ 0,00';
        // Convertir a número y manejar decimales
        const number = Number(value).toFixed(2); // Asegura 2 decimales
        // Separar parte entera y decimal
        const [integerPart, decimalPart] = number.split('.');
        // Formatear parte entera con separador de miles (punto)
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        // Combinar con símbolo de peso y decimales (coma)
        return `$ ${formattedInteger},${decimalPart}`;
    };

    return (
        <>
            {!msjError ? "" : <CustomDialog message={error} btnText="OK" title="Aviso" state={setMostrarMsjError} open={msjError} />}
            <CssBaseline />
            <NavAppBar />
            <Container>
                <Box
                    sx={{
                        maxWidth: 450,
                        mx: 'auto',              // Esto centra horizontalmente
                        mt: 4,                   // opcional: margen superior para separar del NavAppBar
                    }}
                >
                    <Box display="flex" justifyContent="center" margin="dense">
                        <h2>Cotizador Online</h2>
                    </Box>
                    <Box>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="2">Crédito</InputLabel>
                            <Select fullWidth margin='dense' labelId="label" id="1" label="Crédito" value={vehiculo} onChange={handleVehiculo}>
                                {datosVehiculos && datosVehiculos.map((dato) => (<MenuItem key={dato.vehiculoID} value={dato.vehiculoID}>{dato.nombre}</MenuItem>))}
                            </Select>
                        </FormControl>
                        { //vehiculoSelec == "Auto" && (
                            datosModelos && datosModelos.filter((veh) => veh.vehiculoID === vehiculoSelec).length > 0 ? (
                                <>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel id="2">Tipo Crédito</InputLabel>
                                        <Select fullWidth margin='dense' labelId="label" id="2" label="Tipo Crédito" value={credito} onChange={handleCredito} >
                                            {datosCreditos && tiposCredID && datosCreditos.filter(item => tiposCredID.includes(item.tipoCreditoID)).map((dato) => (<MenuItem key={dato.tipoCreditoID} value={dato.tipoCreditoID == null ? '' : dato.tipoCreditoID}>{dato.nombre}</MenuItem>))}
                                        </Select>
                                    </FormControl>
                                    {credito !== 0 && (
                                        <FormControl fullWidth margin="dense">
                                            <InputLabel id="4">Modelo</InputLabel>
                                            <Select fullWidth margin="dense" labelId="label1" id="3" label="Modelo" value={modelo} onChange={handleModelo}>
                                                {datosModelos && datosModelos.filter((row) => row.vehiculoID == vehiculoSelec && row.tipoCreditoID == creditoSelec).map((dato) => (<MenuItem key={dato.modeloID == null ? '' : dato.modeloID} value={dato.modeloID}>{dato.modelo}</MenuItem>))}
                                            </Select>
                                        </FormControl>)}
                                </>
                            ) : ""
                        }
                        <FormControl fullWidth margin="dense">
                            <InputLabel htmlFor="outlined-adornment-amount" >Capital</InputLabel>
                            <OutlinedInput
                                required
                                id="formatted-number-input"
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Capital"
                                value={capital == null ? '' : capital}
                                onChange={handleCapital}
                                inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                    autoComplete: 'off'
                                }}
                            />
                        </FormControl>
                        <>
                            {datosVehiculos != null && vehiculo != 0 && datosVehiculos.find((item) => item.vehiculoID === vehiculo).adelantamientoCuota === true && (
                                <TextField fullWidth margin="dense"
                                    type="number"
                                    label="Cuotas"
                                    value={cuotas == null ? '' : cuotas}
                                    onChange={handleCuotas}
                                    InputProps={{ inputProps: { min: 3, max: 48, pattern: '[0-9]' } }}
                                />
                            )}
                        </>
                        <Grid display="flex" justifyContent="center" margin="dense">
                            <Box margin="dense" >
                                <Button size="medium" onClick={() => handleCotizar(credito, vehiculo, modelo, capital)} margin="dense" type="submit" variant="outlined">SIMULAR</Button>
                            </Box>
                        </Grid>
                    </Box>
                </Box>

                {datosVehiculos != null && vehiculo != 0 && datosVehiculos.find((item) => item.vehiculoID === vehiculo).adelantamientoCuota === true && tasas != null && tasas.result.datos.length !== 0 ? (
                    <>
                        <br />
                        <Grid className="contenedor" container spacing={2}>
                            {tasas != null ? (
                                <>
                                    <CustomBasicTable rows={tasas.result.datos}
                                        columns={[{ id: 'nroCuota', label: 'CUOTA', minWidth: 60, align: 'center' },
                                        /*{ id: 'cuota', label: 'CUOTA', minWidth: 50, align: 'center', format: (value) => value.toLocaleString('es-AR') }*/
                                        { id: 'total', label: 'TOTAL', minWidth: 50, align: 'center', format: (value) => formatCurrency(value) },
                                        { id: 'capital', label: 'CAPITAL', minWidth: 50, align: 'center', format: (value) => formatCurrency(value) },
                                        { id: 'interes', label: 'INTERES', minWidth: 50, align: 'center', format: (value) => formatCurrency(value) },
                                        //{ id: 'cuotaPura', label: 'CUOTA PURA', minWidth: 50, align: 'center', format: (value) => formatCurrency(value) },
                                        { id: 'gastos', label: 'GASTOS', minWidth: 50, align: 'center', format: (value) => formatCurrency(value) },
                                        { id: 'iva', label: 'IVA', minWidth: 50, align: 'center', format: (value) => formatCurrency(value) }
                                        ]}
                                    />
                                    <Grid justifyContent="center" margin="dense">
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            startIcon={<DownloadIcon />}
                                            onClick={async () => {
                                                const blob = await pdf(
                                                    <CotizadorPDF
                                                        credito={datosVehiculos.find(x => x.vehiculoID === vehiculo).nombre}
                                                        capital={capital}
                                                        cuotas={cuotas}
                                                        tasas={tasas}
                                                        user={user}
                                                    />
                                                ).toBlob();

                                                const url = URL.createObjectURL(blob);
                                                const link = document.createElement('a');
                                                const hoy = new Date().toLocaleDateString('es-AR');
                                                const fecha = format(new Date(), 'yyyy-MM-dd'); //hoy.toISOString().split('T')[0]; // → "2025-12-15"
                                                link.href = url;
                                                link.download = `Crédito ${datosVehiculos.find(x => x.vehiculoID === vehiculo).nombre.toLowerCase()}_capital${capital.replace(/\./g, '')}_${cuotas}cuotas_${fecha}.pdf`;
                                                link.click();
                                                URL.revokeObjectURL(url);
                                            }}
                                        >
                                            PDF
                                        </Button>
                                    </Grid>
                                </>
                            ) : ""} {/*('No hay datos para el silo seleccionado.')*/}

                        </Grid>
                        <br />
                    </>
                ) : ""}

                {datosVehiculos != null && vehiculo != 0 && datosVehiculos.find((item) => item.vehiculoID === vehiculo).adelantamientoCuota !== true && tasas != null && tasas.result.datos.length !== 0 ? (
                    <>
                        <br />
                        <Grid className="contenedor" container spacing={0}>
                            {tasas != null ? (
                                <>
                                    <Box
                                        sx={{
                                            maxWidth: 650,
                                            mx: 'auto',              // Esto centra horizontalmente
                                            mt: 4,                   // opcional: margen superior para separar del NavAppBar
                                        }}
                                    >
                                        <CustomBasicTable rows={tasas.result.datos}
                                            columns={[{ id: 'plazo', label: 'PLAZO', minWidth: 60, align: 'center' },
                                            /*{ id: 'cuota', label: 'CUOTA', minWidth: 50, align: 'center', format: (value) => value.toLocaleString('es-AR') }*/
                                            { id: 'cuota', label: 'CUOTA', minWidth: 50, align: 'center', format: (value) => formatCurrency(value) }
                                            ]}
                                        />
                                    </Box>
                                </>
                            ) : ""} {/*('No hay datos para el silo seleccionado.')*/}

                        </Grid>
                        <br />
                    </>
                ) : ""}
            </Container>
        </>
    )
}